









import Vue from 'vue'
export default Vue.extend({
  name: 'cb-card',
  props: {
    bonus: {
      type: Object,
      required: true,
    },
  },
})
